import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
export interface JsonLd {
	[param: string]: string | Object;
}
@Injectable({
	providedIn: 'root'
})

export class BrowserService {
	isBrowser: boolean;
	private jsonLd!: JsonLd | JsonLd[];
	constructor(
		@Inject(PLATFORM_ID) private platformId:any,
		@Inject(DOCUMENT) private readonly document: Document,
	) {
		this.isBrowser = isPlatformBrowser(platformId);
	}

	checkBrowser() {
		if (this.isBrowser) {
			return true;
		} else {
			return false;
		}
	}

	public setJsonLd(renderer2: Renderer2, data: JsonLd | JsonLd[]): void {
		let script = renderer2.createElement('script');
		script.type = 'application/ld+json';
		script.text = `${JSON.stringify(data)}`;
		renderer2.appendChild(this.document.body, script)
	}

	public setData(data: JsonLd | JsonLd[]): void {
		this.jsonLd = data;
		this.inject();
	}

	private inject(): void {
		let ldJsonScriptTag = this.document.head.querySelector(`script[type='application/ld+json']`);
		if (ldJsonScriptTag) {
			ldJsonScriptTag.textContent = JSON.stringify(this.jsonLd);
		} else {
			ldJsonScriptTag = this.document.createElement('script');
			ldJsonScriptTag.setAttribute('type', 'application/ld+json');
			ldJsonScriptTag.textContent = JSON.stringify(this.jsonLd);
			this.document.head.appendChild(ldJsonScriptTag);
		}
	}
}